document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-upsell-add]');
  if (!button) return;

  event.preventDefault();

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(() => {
    // 🔥 Prestige-compatible refresh
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:open', { bubbles: true })
    );
  })
  .catch((error) => {
    console.error('Upsell error:', error);
  });
});